import axios from "axios";
import { Vehicle } from '@/store/types/'

export function getVehicles(filters: any = null) {
  let requestData
  if (typeof filters !== 'undefined') {
    requestData = {
      params: filters
    }
  }
  return axios.get('/vehicles', requestData)
}

export function getVehicle(id: number|string) {
  return axios.get('/vehicles/' + id)
}

export function createVehicle(data: Vehicle) {
  return axios.post('/vehicles', data)
}

export function updateVehicle(id: number|string, data: Vehicle) {
  return axios.put('/vehicles/' + id, data)
}

export function deleteVehicle(id: number|string) {
  return axios.delete('/vehicles/' + id)
}
